import React, { useContext, useState } from "react";
import styled from "styled-components";
import Header from "../components/Header";
import NameCard from "../components/NameCard";
import { TitleText } from "../../../ui/Text";
import { DepartmentIcon } from "../../../assets/svg/DepartmentIcon";
import { AuthContext } from "../../../context/AuthContext";
import { get } from "../../../utils/get";
import { Button } from "../../../ui/Button";
import Modal from "../../../ui/Modal";
import PasswordUpdate from "./PasswordUpdate";
import axios from "../../../utils/axios";
import { USER_URL } from "../../../api/urls";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const Profile = () => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [handleDisable, setHandleDisable] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const [image, setImage] = useState({ preview: "", raw: "" });

  const auth = useContext(AuthContext);

  const { user } = get(auth, "authState");
  console.log('User: ', user?.is_manager);

  const toggleModal = () => {
    setisModalOpen(!isModalOpen);
  };

  const handleChange = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("avatar", image.raw);
    axios.put(`${USER_URL}/${user?.id}`, formData).then((res) => {
      const user = res?.data?.returned_resultset[0];
      localStorage.setItem("user", JSON.stringify(user));
      toast.success("avatar updated successfully");
      window.location.reload();

      setImage({
        preview: "",
        raw: "",
      });
    });
  };

  return (
    <Container>
      <InfoContainer>
        <SectionHeader>
          <TitleText>Basic Information</TitleText>
        </SectionHeader>

        <BasicInfo>
          <UserCard>
            <UsercardTop>
              <img
                src={
                  image?.preview
                    ? image?.preview
                    : get(user, "avatar_url")
                    ? get(user, "avatar_url")
                    : `https://ui-avatars.com/api/?name=${get(user, "first_name")}${get(user, "last_name")}`
                }
                alt=""
              />

              {image?.preview && (
                <button onClick={handleUpload}>update avatar</button>
              )}
              <label htmlFor="upload-avatar">
                <EditButtonSection>Update</EditButtonSection>
                <input
                  type="file"
                  id="upload-avatar"
                  onChange={handleChange}
                  style={{ display: "none" }}
                  accept="image/*"
                />
              </label>
            </UsercardTop>
            <UsercardBottom>
              <NameSection>
                <Text>Names</Text>
                <TitleText>
                  {get(user, "first_name")} {get(user, "last_name")}
                </TitleText>
              </NameSection>
              <NameSection>
                <Text>Email</Text>
                <TitleText>{get(user, "email")}</TitleText>
              </NameSection>
              <NameSection>
                <Text>Job Title</Text>
                <TitleText>{get(user, "job_title")}</TitleText>
              </NameSection>
            </UsercardBottom>
          </UserCard>

          <NameCard title="Staff number" name={get(user, "staff_number")} />
          <NameCard
            title="Organization"
            name={get(user, "organisation.name")}
            icon={<DepartmentIcon fill="white" />}
          />
          <NameCard
            title="Reports to"
            name={
              user?.is_manager
                ? get(user, "organisation.parent_organisation.manager.names")
                : get(user, "organisation.manager.names")
            }
          />
        </BasicInfo>
      </InfoContainer>
      <InfoContainer>
        <SectionHeader>
          <TitleText>Cost and Billing Rates</TitleText>
        </SectionHeader>
        <BasicInfo>
          <NameCard title="Hourly Rate(KES)" name={get(user, "hourly_rate")} />
          <NameCard
            title="Billing Rate(KES)"
            name={get(user, "billing_rate")}
          />
        </BasicInfo>
        <SectionHeader>
          <TitleText>Account Details</TitleText>
        </SectionHeader>
        <BasicInfo>
          <NameCard title="Platform role" name={get(user, "role.name")} />
          <NameCard
            title="Account Status"
            name={get(user, "active") ? "Active" : "Non Active"}
          />
        </BasicInfo>
        <div style={{ margin: "2rem", marginLeft: "auto" }}>
          <Button text="Update password" onClick={toggleModal} />
          {isModalOpen && (
            <Modal
              title={"update password"}
              closeModal={toggleModal}
              handleSubmit={handleSubmit}
              handleDisable={handleDisable}
            >
              <PasswordUpdate
                id={get(user, "id")}
                setHandleSubmit={setHandleSubmit}
                setHandleDisable = {setHandleDisable}
                closeModal={toggleModal}
              />
            </Modal>
          )}
        </div>
      </InfoContainer>
    </Container>
  );
};

export default Profile;

const Container = styled.div`
  display: grid;
  grid-template-rows: 4.3125em 8em 7em 7em;
  grid-template-columns: 1fr 1fr;
  padding-top: 0.75em;
  background-color: #fff;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const BasicInfo = styled.div`
  display: grid;
  grid-template-rows: repeat(auto-fill, 8em);
  grid-template-columns: 1fr 1fr;
`;

const SectionHeader = styled.span`
  padding: 1em;
  margin: 1em;
`;

const UserCard = styled.div`
  grid-row: 1 / span 3;
  width: 300px;
  height: 350px;
  border-radius: 10px;
  margin: 10px;
  background: #f5f6fb;
`;

const UsercardTop = styled.div`
  height: 52%;
  width: 100%;
  overflow: hidden;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  img {
    width: 120px;
    height: 120px;
    margin: 8px 0 0 0;
    border-radius: 50%;
    border: 4px solid white;
    object-fit: cover;
  }
  button {
    background: #01A8CE;
    margin: 1em 0em;
    padding: 0.5em 0.8em;
    color: #fff;
    outline: none;
    border: none;
    font-weight: bolder;
    border-radius: 0.5em;
  }
`;

const UsercardBottom = styled.div`
  min-height: 40%;
  overflow: auto;
  min-width: 100%;
  max-width: 100%;
  padding: 0 10px 5px;
  overflow-wrap: break-word;
`;

const NameSection = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

const Text = styled.h4`
  margin: 0;
  font-size: 0.875em;
  font-weight: normal;
  color: #01A8CE;
  opacity: 0.3;
  line-height: 24px;
`;

const EditButtonSection = styled.span`
  position: absolute;
  text-align: center;
  top: 20%;
  left: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: bold;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  opacity: 0;
  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
`;
